import React from 'react';

export interface TestEdildiBadgeProps {
  className?: string;
  title?: string;
  compact?: boolean;
}

/**
 * Consistent "Test Edildi" badge using primary design tokens.
 */
const TestEdildiBadge: React.FC<TestEdildiBadgeProps> = ({
  className = '',
  title = 'Test Edildi rozeti: ürün doğrulanmış test sürecinden geçmiştir.',
  compact = false,
}) => (
  <span
    className={`sb-tested-badge badge rounded-pill d-inline-flex align-items-center gap-1 fw-semibold ${
      compact ? 'small px-2 py-1' : 'px-3 py-2 small'
    } ${className}`.trim()}
    title={title}
  >
    <i className="fas fa-shield-alt" aria-hidden="true" />
    Test Edildi
  </span>
);

export default TestEdildiBadge;
